import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchBrands'
})
export class SearchBrandsPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if(!items) return [];
    if(!searchText) return items;
searchText = searchText.toLowerCase();
return items.filter( it => {
      return it.brand_name.toLowerCase().includes(searchText);
    });
   }

}
